import Data from "../Data";
import "../Taketour.css";
import StyleItem from "../StyleItem";
import jobsOnboard from "../../../../assets/images/jobsOnboard.png"

const JobPosting = () => {
    const { jobPostingData } = Data();
    return (
        <div className="job-posting">
            {jobPostingData.map((item, index) => (
                <StyleItem key={index} data={item} />
            ))}
            <div id="job-posting-div">
                <img src={jobsOnboard} alt="" />
            </div>
        </div>
    )
}

export default JobPosting
